import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';

interface DisabledFrontendDialogProps {
  open: boolean;
}

const DisabledFrontendDialog: React.FC<DisabledFrontendDialogProps> = ({
  open
}) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
      }}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          zIndex: 9999
        }
      }}
    >
      <DialogTitle>
        <Typography variant="h5" fontWeight="bold">
          Payment Overdue
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ py: 1 }}>
          <Typography variant="body1">
            Your organization currently has an overdue invoice, and access has
            been temporarily suspended. Once payment is received, access will be
            reinstated.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DisabledFrontendDialog;
